import { useJSONEditorStore } from '../useJSONEditorStore';

export const JSONEditorError = ({ message }: { message: string }) => {
  const clearJSON = useJSONEditorStore((state) => state.clearJSON);

  return (
    <div className="w-full rounded bg-red-50 p-4 text-red-500">
      <div className="flex items-center justify-between">
        <div className="font-medium">Error</div>
        <button
          type="button"
          onClick={clearJSON}
          className="rounded border border-secondary bg-white px-2 py-1 text-sm hover:bg-red-100"
        >
          Reset
        </button>
      </div>
      <div className="mt-1 text-sm">{message}</div>
    </div>
  );
};
